import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Edit2, Trash2 } from 'lucide-react';
interface OpportunityCardProps {
  data: any;
  role: 'brand' | 'organizer';
  onEdit?: () => void;
  onDelete?: () => void;
}
export function OpportunityCard({
  data,
  role,
  onEdit,
  onDelete
}: OpportunityCardProps) {
  const accentColor = role === 'brand' ? 'text-cyan-400' : 'text-purple-400';
  const badgeBg = role === 'brand' ? 'bg-cyan-500/10 text-cyan-400 border-cyan-500/20' : 'bg-purple-500/10 text-purple-400 border-purple-500/20';
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="bg-slate-800 border border-slate-700 rounded-xl overflow-hidden hover:border-slate-600 transition-colors group" data-id="element-353">
      <div className="h-32 bg-slate-700 relative" data-id="element-354">
        {data.image ? <img src={data.image} alt={data.title} className="w-full h-full object-cover" data-id="element-355" /> : <div className="w-full h-full flex items-center justify-center text-slate-500 text-sm" data-id="element-356">
            No image
          </div>}
        <div className={`absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-medium border ${badgeBg} backdrop-blur-sm`} data-id="element-357">
          {data.type}
        </div>
      </div>

      <div className="p-5" data-id="element-358">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-359">{data.title}</h3>

        <div className="space-y-2 mb-4" data-id="element-360">
          <div className="flex items-center gap-2 text-sm text-slate-400" data-id="element-361">
            <Calendar size={14} data-id="element-362" />
            <span data-id="element-363">{data.date}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-slate-400" data-id="element-364">
            <MapPin size={14} data-id="element-365" />
            <span data-id="element-366">{data.location}</span>
          </div>
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-slate-700" data-id="element-367">
          <div className="text-sm font-medium text-white" data-id="element-368">
            €{data.budget.toLocaleString()}
          </div>
          <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-369">
            <button onClick={onEdit} className="p-2 text-slate-400 hover:text-white hover:bg-slate-700 rounded-lg transition-colors" data-id="element-370">
              <Edit2 size={14} data-id="element-371" />
            </button>
            <button onClick={onDelete} className="p-2 text-slate-400 hover:text-rose-400 hover:bg-rose-500/10 rounded-lg transition-colors" data-id="element-372">
              <Trash2 size={14} data-id="element-373" />
            </button>
          </div>
        </div>
      </div>
    </motion.div>;
}